import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { AssessmentService } from "../../services/assessment.service";
import { NgbModal, ModalDismissReasons, NgbPaginationConfig, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { CourseService } from '../../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-course-view-course',
  templateUrl: './course-view-course.component.html',
  styleUrls: ['./course-view-course.component.scss']
})
export class CourseViewCourseComponent implements OnInit {

  showDetails: boolean = false;
  activeCourse:boolean=true;
  succesCourse:boolean=false;
  panelOpenState = false;adminData:any;cousesData: any = [];courseForm: any = [];
  activeTab = 0;courseId:any='';tab:any='';courseData:any;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private contentAuthoringApi: ContentAuthoringService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,private toastr: ToastrService,private authCourse:CourseService) {}
  
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }
  open0(content02: any) {
    this.modalService.open(content02, { centered: true, size: 'md' });
  }
  showDetailsEvent() {
    this.showDetails = !this.showDetails;       
    }
    successClick(){
      this.succesCourse=true;
      this.activeCourse=false;
  }
  // /****** start create duplicate course */
  // duplicateCourse() {
  //   /*****get couse detail ****/
  //   this.spinner.show();
  //   this.authCourse.CourseDetail(this.courseId).subscribe(
  //     data => {
  //       this.cousesData = data.courseData;
  //       this.courseForm = {
  //         "course_desc": data.courseData.course_desc,
  //         "course_id": "",
  //         "course_image": data.courseData.course_image,
  //         "course_name": data.courseData.course_name + '_copy',
  //         "course_status": data.courseData.course_status,
  //         "created_by": data.courseData.db_created_dttm,
  //         "end_date": data.courseData.db_end_date,
  //         "is_active": data.courseData.is_active
  //       }
  //       this.authCourse.dublicateCourse(this.courseForm).subscribe(
  //         (data) => {
  //           if (this.cousesData.courseModules.length > 0 && data.status == 201) {
  //             this.getModuleData(data.course_id);
  //           } else {
  //             this.spinner.hide();
  //             document.getElementById('closelId')?.click();
  //           }
  //         }, error => {  this.spinner.hide(); })
  //     })
  // }
  // // getModuleData(courseId: any) {
  // //   if (this.cousesData && this.cousesData.courseModules) {
  // //     let arr: Array<any> = this.cousesData.courseModules;
  // //     arr.forEach(element => {
  // //       element['course_id'] = courseId;
  // //       element['created_dttm'] = element.db_created_dttm;
  // //       element['created_by'] = element.db_created_by;
  // //       let qts = element.subModules;
  // //       for (let n = 0; n < qts.length; n++) {
  // //         qts[n]['course_id'] = courseId;
  // //         qts[n]['created_dttm'] = qts[n].db_created_dttm;
  // //         qts[n]['created_by'] = qts[n].db_created_by;
  // //         if(n < qts.length){
  // //           element['subModules'] = qts;
  // //           this.duplicateModule(element);
  // //         }
  // //       }
       
  // //     })
  // //   }
  // // }
  // getModuleData(courseId: any) {
  //   if (this.cousesData && this.cousesData.courseModules) {
  //     for (let m = 0; m < this.cousesData.courseModules.length; m++) {
       
  //       this.cousesData.courseModules[m]['course_id'] = courseId;
  //       this.cousesData.courseModules[m]['created_dttm'] = this.cousesData.courseModules[m].db_created_dttm;
  //       this.cousesData.courseModules[m]['created_by'] = this.cousesData.courseModules[m].db_created_by;
  //       let qts = this.cousesData.courseModules[m].subModules;
  //       for (let n = 0; n < qts.length; n++) {
  //         qts[n]['course_id'] = courseId;
  //         qts[n]['created_dttm'] = qts[n].db_created_dttm;
  //         qts[n]['created_by'] = qts[n].db_created_by;
  //         if(n < qts.length){
  //           this.cousesData.courseModules[m]['subModules'] = qts;
  //          // this.duplicateModule(this.cousesData.courseModules[m]);
  //           setTimeout(()=>{  
  //             //alert("hello"); 
  //               //console.log(Modueldata); 
  //             this.authCourse.creatModule(this.cousesData.courseModules[m], 'create').subscribe(
  //               data => {
  //                 this.spinner.hide();
  //                // document.getElementById('closelId')?.click();
  //               }, error => {   this.spinner.hide();})
  //             }, 10000);
  //         }
  //       }
  //     }
  //   }
  // }
  // duplicateModule(Modueldata: any) {
   
  //   document.getElementById('closelId')?.click();
    
  //   setTimeout(()=>{  
      
  //   //alert("hello"); 
  //     //console.log(Modueldata); 
  //   this.authCourse.creatModule(Modueldata, 'create').subscribe(
  //     data => {
  //       this.spinner.hide();
  //      // document.getElementById('closelId')?.click();
  //     }, error => {   this.spinner.hide();})
  //   }, 10000);
  // } 
  /****** END create duplicate course */
  logout(){
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
   }
  /*****get couse detail ****/
  getCourseAuthDetails(courseId:any){
    this.spinner.show();
    this.authCourse.CourseDetail(courseId).subscribe(
      data=>{
        console.log(data);
        this.courseData = data.courseData;
        this.spinner.hide();
      },error=>{
        this.spinner.hide();

      }
    )
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(is_active: any) {
    this.authCourse.changeIsActiveVal(this.courseId, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getCourseAuthDetails(this.courseId);
          this.router.navigate(['/courses_view_courses'], { queryParams: { courseId: this.courseId } });
        } else {
         // this.errorInfo.isError = true;
         // this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  getMediaType(mediatypeArr: any, media_type: any) {
    const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
    return mediatypeArr.some(checkMediType);
  }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
      this.tab = queryParams['tab'];
    });
      if (this.courseId != '' && this.courseId != null) {
        this.getCourseAuthDetails(this.courseId);
      }
  }
  /******create duplicate course */
  duplicateCourse(capsule_id: any) {
    /*****get couse detail ****/
    this.spinner.show();
    this.authCourse.CourseDetail(capsule_id).subscribe(
      data => {
        this.cousesData = data.courseData;
        this.courseForm = {
          "course_desc": data.courseData.course_desc,
          "course_id": "",
          "course_image": data.courseData.course_image,
          "course_name": data.courseData.course_name + '_copy',
          //"course_status": data.courseData.course_status,
          "course_status": 1,
          "created_by": data.courseData.db_created_dttm,
          "end_date": data.courseData.db_end_date,
          "is_active": data.courseData.is_active
        }
        this.authCourse.dublicateCourse(this.courseForm).subscribe(
          (data) => {
            if (this.cousesData.courseModules.length > 0 && data.status == 201) {
              this.getModuleData(data.course_id);
             
            } else {
              document.getElementById('closelId')?.click();
              this.spinner.hide();
              this.router.navigate(['/courses']);
              //this.router.navigate(['/courses'], { queryParams: { tab: 1 } });
            }
          }, error => {
            this.spinner.hide();
           })
      })
  }
  getModuleData(courseId: any) {
    if (this.cousesData && this.cousesData.courseModules) {
      let arr: Array<any> = this.cousesData.courseModules;
      arr.forEach((element,i) => {
        setTimeout(() => {
        let qts = element.subModules;
        for (let n = 0; n < qts.length; n++) {
          qts[n]['course_id'] = courseId;
          qts[n]['created_dttm'] = qts[n].db_created_dttm;
          qts[n]['created_by'] = qts[n].db_created_by;
        }
        element['course_id'] = courseId;
        element['created_dttm'] = element.db_created_dttm;
        element['created_by'] = element.db_created_by;
        element['subModules'] = qts;
        if(this.cousesData.courseModules.length-1==i){
          this.duplicateModule(element,1);
        }else{
          this.duplicateModule(element,0);
        }
      }, i*2000);
      })
     // this.spinner.hide();
    }
  }
  /*****create duplicate modules of course */
  duplicateModule(Modueldata: any,status:any) {
    this.authCourse.creatModule(Modueldata, 'create').subscribe(
      data => {
        if(status==1){
          this.router.navigate(['/courses']);
          document.getElementById('closelId')?.click();
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
       })
    
  }

}
